module.exports = __webpack_public_path__ + "img/natick.a07d0a99.svg";